import { render } from "./SwitchCheckbox.vue?vue&type=template&id=26100bea"
import script from "./SwitchCheckbox.vue?vue&type=script&lang=js"
export * from "./SwitchCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__